/* eslint-disable prettier/prettier */
import localize from '../../localize';

export default {
  'taxonomies.kommun': localize('refinementKommun')
    ? localize('refinementKommun')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Tjänst': localize('refinementTjanst')
    ? localize('refinementTjanst')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Län': localize('refinementLan')
    ? localize('refinementLan')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Livsstil': localize('refinementLivsstil')
    ? localize('refinementLivsstil')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'metadata.ssws_driftsform': localize('refinementDriftsform')
    ? localize('refinementDriftsform')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'metadata.ssws_is-new': localize('refinementIsNew')
    ? localize('refinementIsNew')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
};
